import { takeEvery } from 'redux-saga/effects';
import { scheduleInterviewActions } from '../redux';
import {
    fetchScheduleInterviewSaga,
    submitScheduleInterviewSaga,
} from './saga';

export function* scheduleInterviewSaga() {
    yield takeEvery(
        scheduleInterviewActions.fetchScheduleInterview.type,
        fetchScheduleInterviewSaga
    );
    yield takeEvery(
        scheduleInterviewActions.submitScheduleInterview.type,
        submitScheduleInterviewSaga
    );
}
